import React, { Fragment } from "react";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import './TableTeachers.scss'
import {
    defaultPaginationOptions,
    defaultTableHeaderStyles, TableActionIconGeneric,
} from "root/Tables/BaseTableComponents";
import PassportTable, { xlateBootstrapTableColumns } from "root/Tables/PassportTable";
import { customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle } from "root/Tables/BaseTableComponents";
import { TeacherFilter, UserAccountStatus, UserType } from "root/DataFunctions/Constants";
import { AddStaffModalMode } from "root/Modals/ModalAddStaff";
import { Link } from "react-router-dom";
import { isGovernorRole } from "root/DataFunctions/GovernorFunctions";
import { useGlobalContext } from "root/Contexts/GlobalContext";
import { SurveyType } from "root/Contexts/GlobalProvider";

const TableTeachers = ( { filter, loading, data, clickHandler, onClickEditTeacher } ) =>
{
    const {user_type, getCurrentSurveyType} = useGlobalContext();

    const onClickEdit = ( user_id, mode ) =>
    {
        clickHandler ( user_id, mode );
    }

    const onClickResend = ( enc_user_id ) =>
    {
        let provider = 'user' ;

        if ( props.provider_id != null )
        {
            provider = props.provider_id ;
        }

        const url = Globals.APIFolder + '/providers/' + provider + '/staff/' + enc_user_id + '/sendinvitation';

        $.ajax(
            {
                type: 'PUT',
                url: url,
                success: (data) =>
                {
                    if (checkError(data))
                    {
                        displaySuccessMessage() ;
                    }
                },
                error: (jqXHR, textStatus, error) =>
                {
                    handleAjaxError(jqXHR, textStatus, error);
                }
            });
    }

    const headerStyle = customHeaderStyle.bind ( null, {
        default: defaultTableHeaderStyles,
        provider_name: { borderRadius: defaultTopLeftCellStyle, width: "12vw" },
        firstname: { width: "8vw" },
        surname: { width: "8vw" },
        type_description: { width: "15vw" },
        email: { width: "16vw" },
        account_active: { textAlign: 'right', width: "5vw" },
        actions: { borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "10vw" }
    } );

    const actionFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        const rowUserIsPrimary = +(row.primary_dsl_flag) === 1;
        const rowUserIsActivated = row.account_active === 'Y' ;

        const canPromoteUser = +( row.user_type_id ) !== UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER && +( row.user_type_id ) !== UserType.USER_TYPE_GOVERNOR  && ( !rowUserIsPrimary && rowUserIsActivated ) && row.can_promote === true && !isGovernorRole(user_type) && getCurrentSurveyType() !== SurveyType.S360 ;
        const canDeleteUser = !rowUserIsPrimary && !isGovernorRole(user_type);
        const canEditUser = !isGovernorRole(user_type);
        const canSendInviteReminder = !rowUserIsActivated && !isGovernorRole(user_type)  ;

        const provider_id = row.provider_id === undefined ? null : row.provider_id ;

        return <Fragment>
            { canPromoteUser === true &&
                <TableActionIconGeneric onClick={ () => onClickEdit ( row.user_id, AddStaffModalMode.PROMOTE ) } style={ { paddingLeft: '10px' } } icon='bi bi-arrow-bar-up'
                                        color='var(--s360-icon-orange)' text='Promote user to PRIMARY DSL'/> }
            { canSendInviteReminder === true && <TableActionIconGeneric onClick={ () => onClickEdit ( row.user_id, AddStaffModalMode.RESEND ) }
                                                                        style={ { paddingLeft: '10px' } } icon='bi bi-bell'
                                                                        color='var(--s360-icon-orange)' text='Resend New User Invitation'/> }
            { canEditUser === true && <TableActionIconGeneric onClick={ () => onClickEditTeacher ( provider_id, row.user_id, AddStaffModalMode.EDIT ) }
                                                              style={ { paddingLeft: '10px' } } icon='bi bi-pencil'
                                                              color='var(--s360-icon-blue)' text='Edit User Details'/> }
            { canDeleteUser === true && <TableActionIconGeneric onClick={ () => onClickEdit ( row.user_id, AddStaffModalMode.DELETE ) }
                                                                style={ { paddingLeft: '10px' } } icon='bi bi-trash3'
                                                                color='var(--s360-icon-red)' text='Delete This User'/> }
        </Fragment>
    }

    const activeFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        return <Fragment>
            { row.account_active === UserAccountStatus.ACTIVE &&
                <TableActionIconGeneric icon='bi bi-check-circle' color='var(--s360-icon-green)' text='Active'/> }
            { row.account_active === UserAccountStatus.INACTIVE &&
                <TableActionIconGeneric icon='bi bi-hourglass-split' color='var(--s360-icon-blue)'
                                        text='Awaiting activation by user'/> }
            { row.account_active === UserAccountStatus.FAILED &&
                <TableActionIconGeneric icon='bi bi-exclamation-triangle' color='var(--s360-icon-red)'
                                        text='Invitation Failed'/> }
        </Fragment>
    }

    const roleFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        if ( row.primary_dsl_flag === "1" )
        {
            return <span style={ { color: 'var(--s360-icon-green' } }>{ cell + " (Primary)" }</span>
        }
        else
        {
            return <span style={ { color: 'var(--s360-icon-blue' } }>{ cell }</span>
        }
    }

    const schoolFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        const detailURL = '/school/' + row.provider_id + '/detail' ; ;

        return <Link to={detailURL} style={{textDecoration: 'none'}}>{cell}</Link>
    }

    const getColumns = () =>
    {
        const schoolCol = filter === TeacherFilter.PRIMARY_DSL ? [
            {
                dataField: "provider_name",
                text: "Provider",
                formatter: schoolFormatter,
                sort: true,
                headerStyle: headerStyle
            }
        ] : [] ;

        const roleCol = filter !== TeacherFilter.PRIMARY_DSL ? [
            {
                dataField: "type_description",
                text: "Role",
                formatter: roleFormatter,
                sort: true,
                headerStyle: headerStyle
            },
        ] : [] ;

        const columns = [
            ...schoolCol ,
            {
                dataField: "firstname",
                text: "First Name",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "surname",
                text: "Surname",
                sort: true,
                headerStyle: headerStyle
            },
            ...roleCol,
            {
                dataField: "email",
                text: "Email Address",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "account_active",
                text: "Status",
                sort: true,
                align: 'center',
                headerStyle: headerStyle,
                formatter: activeFormatter,
            },
            {
                dataField: "actions",
                text: "Actions",
                sort: false,
                align: 'right',
                headerStyle: headerStyle,
                formatter: actionFormatter,
            }, ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns ( getColumns () );

    const columns = React.useMemo ( () => translations, [] );

    const tableContent = () =>
    {
        return <PassportTable data={ data } isLoading={ loading } columns={ columns }
                              pagination={ defaultPaginationOptions }/>
    }

    return loading === true ? <SpinnerDiv/> : tableContent ();
};

export default TableTeachers;
